// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"fb708896","126":"1b1f2f14","171":"9ebb535d","432":"64b66322","444":"48447112","453":"b6b17d28","507":"501b7c1d","553":"7d4cac41"}[chunkId] + ".chunk.js";
};